import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgMicrophone({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.491 13.626a1 1 0 111.854.75 9.004 9.004 0 01-7.347 5.569L13 20v1a1 1 0 11-2 0v-1l.002-.055a9.004 9.004 0 01-7.346-5.566 1 1 0 011.854-.751 7.002 7.002 0 0012.981-.002zM12 2a5 5 0 015 5v4a5 5 0 01-10 0V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v4a3 3 0 006 0V7a3 3 0 00-3-3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMicrophone
